import React, { Component } from "react";
import { utcToReport24 } from "../../utils/dateConvert";
import { offsetMapLocation } from "../../utils/map";
import _ from "lodash";
import { here_api_key } from "../../utils/mapapi";
import RealMapBubble from "./realMapBubble";
import "../../styles/maps/map.scss";
import { createRoot } from "react-dom/client";

class RealMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoomLevel: 14,
      controlVersion: 0,
      controlScrollLockEnabled: props.scrollLockEnabled,
      controlClusteringEnabled: props.clusteringEnabled !== false,
      controlFollowSelectedAsset: props.followSelectedAsset,
      fullscreenFiltersHidden: false,
    };
    this.arr = [];
    this.truckArr = [];
    this.bubbleObj = null;
    this.bubbleRoot = null;
    this.dataPoints = [];
    this.mapBehaviour = null;
    this.selectedMarker = null;
    this.markerGroup = null;
    this.trackTrailLine = null;
    this.erpGeofenceGroup = null;
    this.ignoreNextMapInteraction = false;
  }

  componentDidMount() {
    // constants
    var platform = new window.H.service.Platform({
      apikey: here_api_key,
    });

    let engineType = window.H.Map.EngineType["HARP"];

    // Obtain the default map types from the platform object
    var maptypes = platform.createDefaultLayers({
      engineType: engineType,
    });

    let defaultLayer = maptypes.vector.normal.map;

    // Instantiate (and display) a map object:
    let map = new window.H.Map(
      document.getElementById("realMapContainer"),
      defaultLayer,
      {
        engineType: engineType,
        center: { lng: 140.4, lat: -37.51 },
        zoom: 14,
      }
    );

    var viewPort = map.getViewPort();
    viewPort.setPadding(50, 300, 50, 300);

    window.map = map;
    window.addEventListener("resize", () => viewPort.resize());
    map.addEventListener("mapviewchangeend", this.updateZoomLevel);
    this.updateZoomLevel();

    this.mapBehaviour = new window.H.mapevents.Behavior(
      new window.H.mapevents.MapEvents(map)
    );

    var scrollBlock = document.getElementById("mapScrollBlock");

    var ctrlDown = false;
    var isMouseOverMap = false;
    var pointerDownPosition = null;
    var mapContainer = document.getElementById("realMapContainer");

    mapContainer.addEventListener("mouseenter", function () {
      isMouseOverMap = true;
    });

    mapContainer.addEventListener("mouseleave", function () {
      isMouseOverMap = false;
    });

    var handleUserMapMove = (event) => {
      if (event.type === "mousedown" || event.type === "touchstart") {
        var point = event.touches && event.touches.length ? event.touches[0] : event;
        pointerDownPosition = {
          x: point.clientX,
          y: point.clientY,
        };
        return;
      }

      if (event.type === "wheel" && this.props.keepFollowOnZoom) {
        return;
      }

      if (
        event.type === "wheel" &&
        this.props.scrollLockEnabled &&
        !ctrlDown
      ) {
        return;
      }

      if (this.ignoreNextMapInteraction) return;
      if (this.props.onUserMove) {
        this.props.onUserMove();
      }
    };

    var handleUserMapPan = (event) => {
      if (!pointerDownPosition) return;
      if (this.ignoreNextMapInteraction) return;

      var point = event.touches && event.touches.length ? event.touches[0] : event;
      var deltaX = Math.abs(point.clientX - pointerDownPosition.x);
      var deltaY = Math.abs(point.clientY - pointerDownPosition.y);
      if (deltaX < 8 && deltaY < 8) return;

      pointerDownPosition = null;
      if (this.props.onUserMove) {
        this.props.onUserMove();
      }
    };

    var clearPointerDownPosition = () => {
      pointerDownPosition = null;
    };

    mapContainer.addEventListener("mousedown", handleUserMapMove);
    mapContainer.addEventListener("touchstart", handleUserMapMove);
    mapContainer.addEventListener("mousemove", handleUserMapPan);
    mapContainer.addEventListener("touchmove", handleUserMapPan);
    document.addEventListener("mouseup", clearPointerDownPosition);
    document.addEventListener("touchend", clearPointerDownPosition);
    mapContainer.addEventListener("wheel", handleUserMapMove);
    this.userMapInteractionListeners = {
      mapContainer,
      handleUserMapMove,
      handleUserMapPan,
      clearPointerDownPosition,
    };

    var checkCtrl = (event) => {
      if (event.key !== "Control") return;
      if (event.repeat) return;

      ctrlDown = event.type === "keydown";

      if (ctrlDown) {
        this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
        scrollBlock.classList.add("fade-out");
        scrollBlock.classList.remove("in");
        setTimeout(() => {
          scrollBlock.classList.remove("fade-out");
        }, 300);
      } else if (this.props.scrollLockEnabled) {
        this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
      }
    };

    // Using global events since we want to capture regardless of where you are on the page
    document.addEventListener("keydown", checkCtrl);
    document.addEventListener("keyup", checkCtrl);

    var scrollTimer = null;

    var self = this;

    // And HERE captures wheel events at the document level so we have to go to the very highest level to undo their mistakes
    window.addEventListener(
      "wheel",
      function (event) {
        if (!isMouseOverMap) return;
        if (ctrlDown) return;
        if (!self.props.scrollLockEnabled) return;
        if (scrollTimer) clearTimeout(scrollTimer);

        scrollBlock.classList.remove("fade-out");
        scrollBlock.classList.add("in");
        scrollTimer = setTimeout(() => {
          scrollBlock.classList.add("fade-out");
          setTimeout(() => {
            scrollBlock.classList.remove("in");
            scrollBlock.classList.remove("fade-out");
            scrollTimer = null;
          }, 300);
        }, 2000);
      },
      {
        capture: true,
        passive: true,
      }
    );

    if (this.props.scrollLockEnabled) {
      this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
    } else {
      this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
    }

    var ui = window.H.ui.UI.createDefault(map, maptypes);

    window.ui = ui;

    // clustering
    this.setTruckPoints(true);
    this.renderErpGeofences();
  }

  componentWillUnmount() {
    if (this.userMapInteractionListeners) {
      const {
        mapContainer,
        handleUserMapMove,
        handleUserMapPan,
        clearPointerDownPosition,
      } = this.userMapInteractionListeners;
      mapContainer.removeEventListener("mousedown", handleUserMapMove);
      mapContainer.removeEventListener("touchstart", handleUserMapMove);
      mapContainer.removeEventListener("mousemove", handleUserMapPan);
      mapContainer.removeEventListener("touchmove", handleUserMapPan);
      mapContainer.removeEventListener("wheel", handleUserMapMove);
      document.removeEventListener("mouseup", clearPointerDownPosition);
      document.removeEventListener("touchend", clearPointerDownPosition);
      this.userMapInteractionListeners = null;
    }
    if (window.map) {
      window.map.removeEventListener("mapviewchangeend", this.updateZoomLevel);
    }
    this.clearSelectedMarker();
    this.clearMarkerGroup();
    this.clearClusterLayer();
    this.clearTrackTrail();
    this.clearErpGeofences();
    this.closeBubble();
  }

  updateZoomLevel = () => {
    if (!window.map) return;
    this.setState({ zoomLevel: Number(window.map.getZoom()).toFixed(1) });
  };

  componentDidUpdate(prevProps) {
    // Check to see if the list of assets has changed.
    // TODO: Only set true when an actual user interaction has occurred, this is only an approximation of that
    var currentAssetList = _.map(this.props.realTimeData, "assetId");
    var previousAssetList = _.map(prevProps.realTimeData, "assetId");

    var hasDifferentAssets =
      _.xor(previousAssetList, currentAssetList).length > 0;
    var isMapChange = this.props.mapChange != prevProps.mapChange;
    var visualModeChanged = this.props.visualMode !== prevProps.visualMode;
    var fitBoundsKeyChanged = this.props.fitBoundsKey !== prevProps.fitBoundsKey;

    if (this.props.erpGeofences !== prevProps.erpGeofences || this.props.erpProgress !== prevProps.erpProgress) {
      this.renderErpGeofences();
    }

    if (visualModeChanged) {
      this.setTruckPoints(false);
    } else if (this.props.clusteringEnabled !== prevProps.clusteringEnabled) {
      this.setTruckPoints(false);
    } else if (fitBoundsKeyChanged) {
      this.setTruckPoints(true);
    } else if (!hasDifferentAssets && isMapChange) {
      if (this.isClusteringEnabled()) {
        this.addClusterPoints(JSON.parse(this.props.mapChange));
      } else {
        this.setTruckPoints(false);
      }
    } else {
      // If we have a lot of assets, it's faster to redraw the whole table
      if (
        this.props.realTimeData.length >= 50 ||
        this.props.realTimeData.length === 1
      ) {
        if (this.props.realTimeData !== prevProps.realTimeData) {
          this.setTruckPoints(
            hasDifferentAssets || this.props.realTimeData.length === 1
          );
        }
      } else if (hasDifferentAssets) {
        this.setTruckPoints(true);
      }
    }

    if (this.props.singleTruckZoom !== prevProps.singleTruckZoom) {
      this.handleTruckZoom(this.props.singleTruckZoom);
    }

    if (this.props.followTruckPosition !== prevProps.followTruckPosition) {
      this.handleTruckFollow(this.props.followTruckPosition);
    }

    if (this.props.trackTrailPoints !== prevProps.trackTrailPoints) {
      this.renderTrackTrail();
    }

    if (this.props.selectedAssetId !== prevProps.selectedAssetId) {
      if (!this.props.selectedAssetId) {
        this.clearSelectedMarker();
        this.closeBubble();
      }

      if (this.dataPoints.length) {
        if (this.isClusteringEnabled()) {
          this.clusterAction(this.dataPoints);
        } else {
          this.renderMarkerGroup(this.dataPoints);
        }
      }
    }

    if (
      this.props.isFullScreen !== prevProps.isFullScreen ||
      this.props.scrollLockEnabled !== prevProps.scrollLockEnabled ||
      this.props.clusteringEnabled !== prevProps.clusteringEnabled ||
      this.props.followSelectedAsset !== prevProps.followSelectedAsset ||
      this.props.selectedAssetId !== prevProps.selectedAssetId
    ) {
      if (!this.props.scrollLockEnabled) {
        this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
      } else {
        this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
      }

      this.setState((state) => ({ controlVersion: state.controlVersion + 1 }));
    }

    if (
      this.props.scrollLockEnabled !== prevProps.scrollLockEnabled ||
      this.props.clusteringEnabled !== prevProps.clusteringEnabled ||
      this.props.followSelectedAsset !== prevProps.followSelectedAsset
    ) {
      this.setState({
        controlScrollLockEnabled: this.props.scrollLockEnabled,
        controlClusteringEnabled: this.props.clusteringEnabled !== false,
        controlFollowSelectedAsset: this.props.followSelectedAsset,
      });
    }
  }

  handleControlScrollLockToggle = (event) => {
    event.currentTarget.blur();
    var controlScrollLockEnabled = !this.state.controlScrollLockEnabled;
    this.setState({ controlScrollLockEnabled });

    if (this.mapBehaviour) {
      if (controlScrollLockEnabled) {
        this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
      } else {
        this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
      }
    }

    if (this.props.onScrollLockToggle) {
      this.props.onScrollLockToggle();
    }
  };

  handleControlClusteringToggle = (event) => {
    event.currentTarget.blur();
    this.setState({ controlClusteringEnabled: !this.state.controlClusteringEnabled });

    if (this.props.onClusteringToggle) {
      this.props.onClusteringToggle();
    }
  };

  handleControlFollowToggle = (event) => {
    event.currentTarget.blur();
    if (!this.props.selectedAssetId) return;

    this.setState({ controlFollowSelectedAsset: !this.state.controlFollowSelectedAsset });

    if (this.props.onFollowSelectedToggle) {
      this.props.onFollowSelectedToggle();
    }
  };

  stopOverlayMapInteraction = (event) => {
    event.stopPropagation();
  };

  hideFullscreenFilters = (event) => {
    event.stopPropagation();
    this.setState({ fullscreenFiltersHidden: true });
  };

  showFullscreenFilters = (event) => {
    event.stopPropagation();
    this.setState({ fullscreenFiltersHidden: false });
  };

  handleClearSelectedAsset = (event) => {
    event.currentTarget.blur();
    event.stopPropagation();
    this.clearSelectedMarker();
    this.closeBubble();

    if (this.props.onClearSelectedAsset) {
      this.props.onClearSelectedAsset();
    }
  };

  handleTruckZoom = async (data) => {
    var position = {
      lat: data.lat,
      lng: data.lng,
    };

    if (this.props.scrollToTopOnSelection !== false) {
      window.scrollTo(0, 0);
    }

    window.map.setZoom(Math.max(window.map.getZoom(), 16));
    window.map.setCenter(position);
    this.renderSelectedMarker(data);

    if (this.props.isFullScreen) {
      this.handleOpenBubble(position, data);
      return;
    }

    this.closeBubble();
  };

  handleTruckFollow = async (data) => {
    if (!data || !data.lat || !data.lng) return;

    var position = {
      lat: data.lat,
      lng: data.lng,
    };

    window.map.setCenter(position);
    this.renderSelectedMarker(data);

    if (this.props.isFullScreen) {
      this.handleOpenBubble(position, data);
      return;
    }

    this.closeBubble();
  };

  getMarkerStatus = (data) => {
    if (!data || data.gprs != 1) return "offline";
    return data.parking == 1 ? "driving" : "parked";
  };

  getMarkerPalette = (status, isSelected) => {
    var palettes = {
      driving: {
        fill: "#16a34a",
        stroke: "#86efac",
        text: "#15803d",
        tint: isSelected ? "#bbf7d0" : "#16a34a",
      },
      parked: {
        fill: "#2563eb",
        stroke: "#93c5fd",
        text: "#1d4ed8",
        tint: isSelected ? "#bfdbfe" : "#2563eb",
      },
      offline: {
        fill: "#dc2626",
        stroke: "#fca5a5",
        text: "#b91c1c",
        tint: isSelected ? "#fecaca" : "#dc2626",
      },
    };

    return palettes[status] || palettes.parked;
  };

  getDefaultMarkerPalette = (isSelected) => ({
    fill: "#312ec7",
    stroke: "#a5b4fc",
    text: "#312ec7",
    tint: isSelected ? "#eef2ff" : "#312ec7",
  });

  normalizeMarkerColour = (colour) => {
    var value = String(colour || "").trim();
    if (/^#[0-9a-fA-F]{6}$/.test(value)) return value;
    if (/^[0-9a-fA-F]{6}$/.test(value)) return `#${value}`;
    return "";
  };

  getCustomMarkerPalette = (palette, colour, isSelected) => {
    var markerColour = this.normalizeMarkerColour(colour);
    if (!markerColour) return palette;

    return {
      fill: markerColour,
      stroke: isSelected ? "#ffffff" : markerColour,
      text: markerColour,
      tint: isSelected ? "#ffffff" : markerColour,
    };
  };

  getMarkerIconKey = (icon) => {
    var rawValue = String(icon || "").trim().toLowerCase();
    var tokens = rawValue.split(/\s+/);
    var iconToken = tokens.find((token) => token.indexOf("fa-") === 0);
    return String(iconToken || rawValue)
      .replace(/^fa-/, "")
      .replace(/[^a-z0-9-]/g, "");
  };

  getMarkerShapeSvg = (icon, fill, stroke, heading) => {
    var iconKey = this.getMarkerIconKey(icon);
    var rotation = 90 + (Number(heading) || 0);
    var aliases = {
      "fa-car": "car",
      taxi: "car",
      "video-camera": "camera",
      "map-marker": "portable",
      location: "portable",
      flag: "portable",
      briefcase: "portable",
      suitcase: "portable",
      plant: "plant-equipment",
      equipment: "plant-equipment",
      excavator: "plant-equipment",
      prime: "prime-mover",
      "prime-mover": "prime-mover",
    };
    iconKey = aliases[iconKey] || iconKey || "truck";

    var defs = `<defs>
        <linearGradient id="assetMarkerGradient" x1="12" x2="60" y1="22" y2="52">
          <stop offset="0" stop-color="#7478ff"/>
          <stop offset="0.56" stop-color="${fill}"/>
          <stop offset="1" stop-color="#18147c"/>
        </linearGradient>
      </defs>`;
    var shadow = `<ellipse cx="36" cy="57" rx="24" ry="4" fill="#0f172a" opacity=".16"/>`;
    var common = {
      fill: `url(#assetMarkerGradient)`,
      outline: `stroke="${stroke}" stroke-width="1.1"`,
      window: `fill="#dbeafe"`,
      shine: `fill="#ffffff" opacity=".28"`,
      tyre: `fill="#111827"`,
      rim: `fill="#94a3b8"`,
      front: `fill="#fef3c7"`,
      rear: `fill="#fecaca"`,
    };

    var shapes = {
      car: `<path ${common.outline} fill="${common.fill}" d="M13 42c0-2 1.6-3.6 3.6-3.6h3.2l4.4-9.8c.8-1.7 2.5-2.8 4.4-2.8H43c1.9 0 3.6 1.1 4.4 2.8l4.4 9.8h3.1c2 0 3.6 1.6 3.6 3.6v6.1H13z"/>
        <path ${common.window} d="M27.7 29.6h16.1l3 8.2H24.2z"/>
        <path ${common.shine} d="M18.5 41.2h32.8c-7.2 2.3-20.8 3-32.8 1.2z"/>
        <rect ${common.front} x="54.5" y="41.5" width="3.1" height="2.8" rx="1.2"/>
        <rect ${common.rear} x="13.5" y="41.5" width="2.4" height="2.8" rx="1.1"/>
        <circle ${common.tyre} cx="24" cy="49" r="4.4"/><circle ${common.tyre} cx="49" cy="49" r="4.4"/>
        <circle ${common.rim} cx="24" cy="49" r="1.8"/><circle ${common.rim} cx="49" cy="49" r="1.8"/>`,
      ute: `<path ${common.outline} fill="${common.fill}" d="M12 48V39h14l4.2-9.8H44l5.3 9.8H60v9z"/>
        <path ${common.window} d="M31.8 32.3h10.5l3.2 6.4H29.1z"/>
        <path ${common.shine} d="M15.5 40.7H58c-10 3-28 3.4-42.5 1.2z"/>
        <rect ${common.front} x="57" y="42" width="3" height="2.7" rx="1.1"/>
        <rect ${common.rear} x="12.2" y="42" width="2.4" height="2.7" rx="1"/>
        <circle ${common.tyre} cx="25" cy="49" r="4.4"/><circle ${common.tyre} cx="51" cy="49" r="4.4"/>
        <circle ${common.rim} cx="25" cy="49" r="1.8"/><circle ${common.rim} cx="51" cy="49" r="1.8"/>`,
      van: `<path ${common.outline} fill="${common.fill}" d="M13 30h39c4 0 7 3 7 7v11H13z"/>
        <path ${common.window} d="M19 34h15v7H19zM39 34h10v7H39z"/>
        <path ${common.shine} d="M17 31.8h32c-8.6 2.4-19.8 2.7-32 1.2z"/>
        <rect ${common.front} x="56.5" y="40.5" width="3" height="2.8" rx="1.1"/>
        <rect ${common.rear} x="13.4" y="40.5" width="2.4" height="2.8" rx="1"/>
        <circle ${common.tyre} cx="25" cy="49" r="4.4"/><circle ${common.tyre} cx="51" cy="49" r="4.4"/>
        <circle ${common.rim} cx="25" cy="49" r="1.8"/><circle ${common.rim} cx="51" cy="49" r="1.8"/>`,
      trailer: `<rect ${common.outline} x="15" y="30" width="40" height="17" rx="4" fill="${common.fill}"/>
        <path ${common.shine} d="M19 32h31c-8 2.2-19.4 2.5-31 1.2z"/>
        <path d="M55 38h6" stroke="#18147c" stroke-width="3" stroke-linecap="round"/>
        <rect ${common.front} x="54" y="38.5" width="2.8" height="2.8" rx="1"/>
        <rect ${common.rear} x="15.6" y="38.5" width="2.4" height="2.8" rx="1"/>
        <circle ${common.tyre} cx="27" cy="49" r="4.3"/><circle ${common.tyre} cx="45" cy="49" r="4.3"/>
        <circle ${common.rim} cx="27" cy="49" r="1.7"/><circle ${common.rim} cx="45" cy="49" r="1.7"/>`,
      truck: `<rect ${common.outline} x="13" y="31" width="30" height="17" rx="4" fill="${common.fill}"/>
        <path ${common.outline} fill="${common.fill}" d="M43 34h8l7 7v7H43z"/>
        <path ${common.window} d="M47 36.5h3.4l3.5 4.2H47z"/>
        <path ${common.shine} d="M17 33h23c-6.8 2-15.6 2.3-23 1.2z"/>
        <rect ${common.front} x="56.5" y="42" width="3" height="2.8" rx="1"/>
        <rect ${common.rear} x="13.5" y="42" width="2.4" height="2.8" rx="1"/>
        <circle ${common.tyre} cx="24" cy="49" r="4.4"/><circle ${common.tyre} cx="52" cy="49" r="4.4"/>
        <circle ${common.rim} cx="24" cy="49" r="1.8"/><circle ${common.rim} cx="52" cy="49" r="1.8"/>`,
      "prime-mover": `<rect ${common.outline} x="13" y="36" width="25" height="11" rx="3" fill="${common.fill}"/>
        <path ${common.outline} fill="${common.fill}" d="M38 29h10l10 10v8H38z"/>
        <path ${common.window} d="M43 32h4.5l5.5 5.8H43z"/>
        <path ${common.shine} d="M41 30.7h8c-2.6 1.2-5.3 1.7-8 1.6z"/>
        <rect ${common.front} x="57" y="41.5" width="3" height="2.8" rx="1"/>
        <rect ${common.rear} x="13.4" y="40.5" width="2.4" height="2.8" rx="1"/>
        <circle ${common.tyre} cx="22" cy="49" r="4.2"/><circle ${common.tyre} cx="43" cy="49" r="4.2"/><circle ${common.tyre} cx="53" cy="49" r="4.2"/>
        <circle ${common.rim} cx="22" cy="49" r="1.7"/><circle ${common.rim} cx="43" cy="49" r="1.7"/><circle ${common.rim} cx="53" cy="49" r="1.7"/>`,
      camera: `<rect ${common.outline} x="16" y="31" width="31" height="19" rx="6" fill="${common.fill}"/>
        <path ${common.outline} fill="${common.fill}" d="M47 36l11-7v23l-11-7z"/>
        <circle ${common.window} cx="31.5" cy="40.5" r="7.2"/>
        <circle fill="#18147c" cx="31.5" cy="40.5" r="3.5"/>
        <path d="M22 34h12" stroke="#fff" stroke-width="2.2" opacity=".38" stroke-linecap="round"/>
        <rect ${common.front} x="57" y="39" width="2.4" height="3" rx="1"/>`,
      "plant-equipment": `<path ${common.outline} fill="${common.fill}" d="M16 48h38l-4-14H36l-5-7H20z"/>
        <path fill="${fill}" d="M36 34l16-9 5 9z"/>
        <path ${common.shine} d="M22 35h19c-5.2 2.1-12.6 2.5-19 1.1z"/>
        <rect ${common.front} x="54.2" y="39.5" width="3" height="2.8" rx="1"/>
        <circle ${common.tyre} cx="26" cy="50" r="4.6"/><circle ${common.tyre} cx="48" cy="50" r="4.6"/>
        <circle ${common.rim} cx="26" cy="50" r="1.8"/><circle ${common.rim} cx="48" cy="50" r="1.8"/>`,
      portable: `<path ${common.outline} fill="${common.fill}" d="M20 31h32c2.2 0 4 1.8 4 4v16H16V35c0-2.2 1.8-4 4-4z"/>
        <path d="M28 31v-4.5c0-2 1.6-3.5 3.5-3.5h9c2 0 3.5 1.6 3.5 3.5V31h-4v-3.8H32V31z" fill="#18147c"/>
        <path ${common.shine} d="M20 34h31c-8.2 2.3-19.4 2.6-31 1.1z"/>
        <rect ${common.front} x="53.5" y="40.5" width="3" height="3" rx="1"/>
        <rect ${common.rear} x="15.8" y="40.5" width="2.5" height="3" rx="1"/>
        <rect x="33" y="40" width="6" height="4" rx="1" fill="#dbeafe"/>`,
    };

    return `${defs}${shadow}<g transform="rotate(${rotation} 36 36)">${shapes[iconKey] || shapes.truck}</g>`;
  };

  getLegacyTruckShapeSvg = (fill, stroke, heading) => {
    var flipTransform = heading >= 0 && heading <= 180 ? "scale(1, -1) translate(0, -48)" : "";

    return `<g transform="rotate(${90 + heading} 24 24)">
      <path transform="${flipTransform}" fill="${fill}" stroke="${stroke}" stroke-width="0.09375" opacity="1.00" d=" M 14.00 7.00 C 23.99 7.10 34.00 6.81 43.98 7.12 C 46.27 7.06 47.71 9.13 48.00 11.19 L 48.00 34.74 C 46.70 34.75 45.39 34.77 44.09 34.78 C 43.22 37.74 41.36 41.02 37.85 41.05 C 33.99 41.52 31.33 38.18 30.59 34.76 C 26.53 34.73 22.47 34.75 18.40 34.79 C 17.73 37.91 15.52 41.23 11.93 41.03 C 8.37 41.38 5.88 38.22 5.15 35.06 C 3.43 34.98 1.72 34.91 0.00 34.86 L 0.00 34.13 C 1.54 31.02 0.97 27.53 0.98 24.20 C 3.15 21.29 5.33 18.38 7.54 15.50 C 9.69 15.50 11.84 15.50 13.99 15.51 C 14.00 12.67 14.00 9.84 14.00 7.00 M 4.47 24.00 C 7.64 24.01 10.82 23.99 14.00 24.00 C 13.99 22.25 13.99 20.51 14.00 18.76 C 12.21 18.75 10.42 18.74 8.63 18.71 C 7.21 20.45 5.80 22.20 4.47 24.00 M 9.46 32.55 C 6.46 35.27 11.30 40.01 14.02 36.96 C 17.06 34.09 12.19 29.35 9.46 32.55 M 35.22 32.34 C 32.06 34.77 36.33 39.82 39.28 37.21 C 42.76 34.83 38.22 29.27 35.22 32.34 Z" />
    </g>`;
  };

  isClusteringEnabled = () => this.props.clusteringEnabled !== false;

  clearSelectedMarker = () => {
    if (this.selectedMarker && window.map) {
      window.map.removeObject(this.selectedMarker);
      this.selectedMarker = null;
    }
  };

  clearClusterLayer = () => {
    if (this.clusterLayer && window.map) {
      window.map.removeLayer(this.clusterLayer);
      this.clusterLayer = null;
    }
    if (window.clusteredDataProvider) {
      window.clusteredDataProvider.removeEventListener(
        "tap",
        this.onMarkerClick
      );
      window.clusteredDataProvider = null;
    }
  };

  clearMarkerGroup = () => {
    if (this.markerGroup && window.map) {
      window.map.removeObject(this.markerGroup);
      this.markerGroup = null;
    }
  };

  clearTrackTrail = () => {
    if (this.trackTrailLine && window.map) {
      window.map.removeObject(this.trackTrailLine);
      this.trackTrailLine = null;
    }
  };

  clearErpGeofences = () => {
    if (this.erpGeofenceGroup && window.map) window.map.removeObject(this.erpGeofenceGroup);
    this.erpGeofenceGroup = null;
  };

  renderErpGeofences = () => {
    if (!window.map || !window.H) return;
    this.clearErpGeofences();
    const geofences = Array.isArray(this.props.erpGeofences) ? this.props.erpGeofences : [];
    if (!geofences.length) return;
    const group = new window.H.map.Group();
    geofences.forEach((geofence) => {
      const lat = Number(geofence.lat);
      const lng = Number(geofence.lng);
      const stopNo = Number(geofence.firstDrop);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      const status = this.props.erpProgress && this.props.erpProgress.stopStates && this.props.erpProgress.stopStates[String(stopNo)];
      const completed = status && status.status === "completed";
      const current = status && status.status === "current";
      const colour = completed ? "rgba(22,163,74,0.96)" : current ? "rgba(37,99,235,0.96)" : "rgba(249,115,22,0.96)";
      const fill = completed ? "rgba(134,239,172,0.28)" : current ? "rgba(147,197,253,0.28)" : "rgba(253,186,116,0.20)";
      group.addObject(new window.H.map.Circle({ lat, lng }, Math.max(50, Number(geofence.radiusM) || 0), {
        style: { strokeColor: colour, fillColor: fill, lineWidth: completed || current ? 4 : 2 }
      }));
      const label = String(geofence.customerName || geofence.customerCode || `Stop ${stopNo}`);
      const safeLabel = label.replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character]));
      const icon = new window.H.map.DomIcon(`<div class="erp-map-stop-label ${completed ? "completed" : current ? "current" : ""}"><b>${stopNo}</b><span>${safeLabel}</span></div>`);
      group.addObject(new window.H.map.DomMarker({ lat, lng }, { icon }));
    });
    window.map.addObject(group);
    this.erpGeofenceGroup = group;
  };

  renderTrackTrail = () => {
    if (!window.map) return;

    this.clearTrackTrail();

    var trailPoints = (this.props.trackTrailPoints || []).filter((point) => point && point.lat !== undefined && point.lat !== null && point.lng !== undefined && point.lng !== null);
    if (trailPoints.length < 2) return;

    var lineString = new window.H.geo.LineString();
    trailPoints.forEach((point) => {
      lineString.pushLatLngAlt(Number(point.lat), Number(point.lng));
    });

    this.trackTrailLine = new window.H.map.Polyline(lineString, {
      style: {
        lineWidth: 4,
        lineJoin: "round",
        strokeColor: "rgba(220, 38, 38, 0.92)",
      },
    });

    if (this.trackTrailLine.setZIndex) {
      this.trackTrailLine.setZIndex(20);
    }

    window.map.addObject(this.trackTrailLine);
  };

  renderSelectedMarker = (data) => {
    if (!window.map || !data || !data.lat || !data.lng) return;

    var position = {
      lat: data.lat,
      lng: data.lng,
    };

    this.clearSelectedMarker();

    this.selectedMarker = new window.H.map.Marker(position, {
      icon: this.getTruckIcon(data.name, data.heading, true, this.getMarkerStatus(data), {
        customColour: data.colour,
        customIcon: data.icon,
        visualMode: this.props.visualMode,
        customVisualsEnabled: this.props.customVisualsEnabled,
      }),
    });
    this.selectedMarker.setData(data);
    if (this.selectedMarker.setZIndex) {
      this.selectedMarker.setZIndex(1000);
    }
    this.selectedMarker.addEventListener("tap", () => {
      if (this.props.onAssetSelection) {
        this.props.onAssetSelection(data.assetId);
      }
    });
    window.map.addObject(this.selectedMarker);
  };

  addClusterPoint = (data) => {
    if (data.lastMessage) {
      this.checkUpdateDataPoint(data);
      const optData = {
        assetId: data.lastMessage.assetID,
        created: data.lastMessage.created,
        address: data.lastMessage.location,
        lat: data.lastMessage.gPRMC.latitude,
        lng: data.lastMessage.gPRMC.longitude,
        speed: data.lastMessage.gPRMC.speed,
        odometer: data.lastMessage.odometer,
        name: data.assetName,
        tempA: data.lastMessage.sensorAValue || "",
        tempB: data.lastMessage.sensorBValue || "",
        fridge: this.handleFridge(
          data.lastMessage.iO1,
          data.lastMessage.sensorBValue
        ),
        gprs: data.lastMessage.gprsOnline,
        heading: data.lastMessage.gPRMC.heading,
        parking: data.lastMessage.iO3,
        trip: data.lastMessage.tripCount,
        duress: data.lastDuress || "",
        volt: data.lastMessage.deviceVolts,
        satelite: data.lastMessage.satellites,
	        lastUpdated: data.lastMessage.received,
	        friendlyName: data.friendlyName,
	        colour: data.colour || data.Colour || data.groupColour || data.GroupColour || "",
	        icon: data.icon || data.Icon || data.groupIcon || data.GroupIcon || "",
	        lastDuress: data.lastDuress || "",
        lastPowerCut: data.lastPowerCut || "",
        lastStatusChange: data.lastStatusChange || "",
      };
      let lat = data.lastMessage.gPRMC.latitude;
      let lng = data.lastMessage.gPRMC.longitude;

      var dataPoint = new window.H.clustering.DataPoint(
        lat,
        lng,
        null,
        optData
      );
      this.dataPoints.push(dataPoint);

      window.clusteredDataProvider.addDataPoint(dataPoint);
      if (String(optData.assetId) === String(this.props.selectedAssetId)) {
        this.renderSelectedMarker(optData);
      }
    }
  };

  addClusterPoints = (data) => {
    var updates = Array.isArray(data) ? data : [data];
    updates.forEach((update) => this.addClusterPoint(update));
  };

  checkUpdateDataPoint = (data) => {
    var assetIdToMatch = data.lastMessage.assetID;

    this.dataPoints.forEach((point, index) => {
      if (point.data.assetId == assetIdToMatch) {
        this.removeClusterPoint(point);
      }
    });

    _.remove(this.dataPoints, function (point) {
      return point.data.assetId == assetIdToMatch;
    });
  };

  removeClusterPoint = (dataPoint) => {
    window.clusteredDataProvider.removeDataPoint(dataPoint);
  };

  changeTruckArr = (data) => {
    let currentList = [...this.truckArr];
    currentList.forEach((single, index) => {
      if (single.id == data.assetId) {
        const optData = {
          created: data.lastMessage.created,
          speed: data.lastMessage.gPRMC.speed,
        };
        const dataPoint = {
          id: data.assetId,
          lat: data.lastMessage.gPRMC.latitude,
          lng: data.lastMessage.gPRMC.longitude,
          optData: optData,
        };

        currentList[index] = dataPoint;
        this.truckArr = currentList;
      }

      this.mapSetting();
    });
  };

  mapSetting = () => {
    var dataPoints = [];
    this.truckArr.forEach((single) => {
      dataPoints.push(
        new window.H.clustering.DataPoint(
          single.lat,
          single.lng,
          null,
          single.optData
        )
      );
    });

    if (this.isClusteringEnabled()) {
      this.clusterAction(dataPoints);
    } else {
      this.renderMarkerGroup(dataPoints);
    }
  };

  setTruckPoints = async (setBounds) => {
    let newResponse = this.setResponseData(this.props.realTimeData);
    this.createDataPoints(newResponse);
    var dataPoints = [];
    var selectedTruck = this.truckArr.find((point) => String(point.id) === String(this.props.selectedAssetId));
    var shouldSetBounds = setBounds && (!selectedTruck || this.props.fitFilteredAssets);
    var shouldCenterSelectedTruck = selectedTruck && !this.props.fitFilteredAssets;

    if (shouldSetBounds) {
      if (this.truckArr.length > 1) {
        let lineString = new window.H.geo.LineString();
        let polyline;
        this.truckArr.forEach((point) => {
          lineString.pushLatLngAlt(point.lat, point.lng);
        });

        polyline = new window.H.map.Polyline(lineString, {
          style: {
            lineWidth: 3,
            strokeColor: "rgba(239, 93, 231, 0.8)",
          },
        });

        // And zoom to its bounding rectangle
        window.map.getViewModel().setLookAtData({
          bounds: polyline.getBoundingBox(),
        });
      } else if (this.truckArr.length === 1) {
        window.map.setCenter({
          lat: this.truckArr[0].lat,
          lng: this.truckArr[0].lng,
        });
      }

      // If only a single truck, zoom to show it
      if (this.truckArr.length === 1) {
        let userZoom = window.map.getZoom();
        if (userZoom === 0) {
          window.map.setZoom(14);
        } else {
          window.map.setZoom(window.map.getZoom());
        }
      }

      if (this.bubbleObj) {
        if (this.bubbleObj.getState() !== "closed") {
          var data = this.truckArr.slice(-1)[0];
          if (data) {
            let newPosition = {
              lat: data.lat,
              lng: data.lng,
            };
            this.bubbleObj.setPosition(newPosition);
            this.bubbleObj.setContent(
              await this.getBubbleContent(data.optData)
            );
          }
        }
      }
    }

    this.truckArr.forEach((single) => {
      dataPoints.push(
        new window.H.clustering.DataPoint(
          single.lat,
          single.lng,
          null,
          single.optData
        )
      );
    });
    this.dataPoints = dataPoints;

    if (this.isClusteringEnabled()) {
      this.clusterAction(dataPoints);
    } else {
      this.renderMarkerGroup(dataPoints);
    }

    if (shouldCenterSelectedTruck) {
      var selectedPosition = {
        lat: selectedTruck.lat,
        lng: selectedTruck.lng,
      };
      window.map.setCenter(selectedPosition);
      this.renderSelectedMarker(selectedTruck.optData);
    } else if (selectedTruck) {
      this.renderSelectedMarker(selectedTruck.optData);
    }
  };

  setResponseData = (data) => {
    let newData = [];
    data &&
      data.length > 0 &&
      data.forEach((datum) => {
        if (datum.lastMessage != null) {
          datum.lastMessage.name = datum.assetName;
          datum.lastMessage.powerCut = datum.lastPowerCut || "";
          datum.lastMessage.duress = datum.lastDuress || "";
          datum.lastMessage.lastStatusChange = datum.lastStatusChange || "";
	          datum.lastMessage.friendlyName = datum.friendlyName || "";
	          datum.lastMessage.colour = datum.colour || datum.Colour || datum.groupColour || datum.GroupColour || "";
	          datum.lastMessage.icon = datum.icon || datum.Icon || datum.groupIcon || datum.GroupIcon || "";

          newData.push(datum.lastMessage);
        }
      });

    return newData;
  };

  handleNullCheck = (value, index) => {
    if (
      this.props.realTimeData[index].message &&
      this.props.realTimeData[index].message.gPRMC
    ) {
      let thing = this.props.realTimeData[index].message.gPRMC[value];
      return thing;
    } else {
      return null;
    }
  };

  handleFridge = (tempA, tempB) => {
    if (tempA == 1) return "On";
    return "Off";
  };

  createDataPoints = (data) => {
    this.truckArr = [];

    data.forEach((datum) => {
      if (datum.gPRMC) {
        const optData = {
          assetId: datum.assetID,
          created: datum.created,
          lat: datum.gPRMC.latitude,
          lng: datum.gPRMC.longitude,
          address: datum.location,
          speed: datum.gPRMC.speed,
          odometer: datum.odometer,
          name: datum.name,
          tempA: datum.sensorAValue || "",
          tempB: datum.sensorBValue || "",
          fridge: this.handleFridge(datum.iO1, datum.sensorBValue),
          gprs: datum.gprsOnline,
          heading: datum.gPRMC.heading,
          parking: datum.iO3,
          trip: datum.tripCount,
          duress: datum.duress ? utcToReport24(datum.duress.created) : "",
          volt: datum.deviceVolts,
          // gprs: data.iO1,
	          friendlyName: datum.friendlyName || "",
	          colour: datum.colour || datum.Colour || "",
	          icon: datum.icon || datum.Icon || "",
	          satelite: datum.satellites,
          lastUpdated: datum.received,
          lastDuress: datum.duress || "",
          lastPowerCut: datum.powerCut || "",
          lastStatusChange: datum.lastStatusChange || "",
        };
        const dataPoint = {
          id: datum.assetID,
          lat: datum.gPRMC.latitude,
          lng: datum.gPRMC.longitude,
          optData: optData,
        };
        this.truckArr.push(dataPoint);
      }
    });
  };

  escapeSvgText = (value) =>
    String(value || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  getHiddenIcon = () =>
    new window.H.map.Icon(
      `<svg width="1" height="1" viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg"></svg>`,
      {
        size: { w: 1, h: 1 },
        anchor: { x: 0, y: 0 },
      }
    );

  getLabelWidth = (value) => {
    var text = String(value || "");
    var width = 0;

    for (var index = 0; index < text.length; index += 1) {
      var character = text[index];
      if (character === " ") width += 4;
      else if (character === "_" || character === "-") width += 7;
      else if (/[A-Z0-9]/.test(character)) width += 9.5;
      else width += 8;
    }

    return Math.max(68, Math.ceil(width) + 32);
  };

  getTruckIcon = (name, heading, isSelected, status, options = {}) => {
    var visualMode = options.visualMode || (options.customVisualsEnabled === true ? "custom" : "ignition");
    var useCustomVisuals = visualMode === "custom";
    var basePalette = visualMode === "ignition" || useCustomVisuals
      ? this.getMarkerPalette(status, isSelected)
      : this.getDefaultMarkerPalette(isSelected);
    var useCustomColour = visualMode === "default" || useCustomVisuals;
    var palette = useCustomColour
      ? this.getCustomMarkerPalette(
        basePalette,
        options.customColour,
        isSelected
      )
      : basePalette;
    var markerFill = palette.fill;
    var markerStroke = palette.stroke;
    var rawName = String(name || "");
    var safeName = this.escapeSvgText(rawName);

    if (!isSelected) {
      var showLabel = options.showLabel !== false;
      var standardWidth = showLabel ? 560 : 44;
      var standardSvgWidth = showLabel ? 1000 : 72;
      var standardText = showLabel
        ? `<text x="78" y="42" fill="${palette.fill}" font-family="sans-serif" font-weight="700" font-size="2.25rem" id="text56">${safeName}</text>`
        : "";
      var standardSvgTruck = `<svg height="72" version="1.1" viewBox="0 0 ${standardSvgWidth} 72" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">
          ${useCustomVisuals
            ? this.getMarkerShapeSvg(options.customIcon, markerFill, markerStroke, heading)
            : this.getLegacyTruckShapeSvg(markerFill, markerStroke, heading)}
          ${standardText}
      </svg>`;

      return new window.H.map.Icon(standardSvgTruck, {
        size: { w: standardWidth, h: 44 },
        anchor: { x: 22, y: 22 },
      });
    }

    var labelX = 78;
    var labelHeight = 26;
    var labelY = 23;
    var labelWidth = this.getLabelWidth(rawName);
    var labelCenterX = labelX + labelWidth / 2;
    var selectedWidth = labelX + labelWidth + 10;
    var statusPalette = palette;
    var svgTruck = `<svg width="${selectedWidth}" height="72" version="1.1" viewBox="0 0 ${selectedWidth} 72" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">
          <defs>
            <filter id="selectedShadow" x="-20%" y="-60%" width="160%" height="220%">
              <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#0f172a" flood-opacity="0.32"/>
            </filter>
          </defs>
          <g filter="url(#selectedShadow)">
            <rect x="${labelX}" y="${labelY}" width="${labelWidth}" height="${labelHeight}" rx="7" fill="${statusPalette.tint}" stroke="${statusPalette.fill}" stroke-width="2.5" />
            <text x="${labelCenterX}" y="${labelY + labelHeight / 2 + 1}" fill="${statusPalette.text}" font-family="sans-serif" font-weight="800" font-size="14" text-anchor="middle" dominant-baseline="middle">${safeName}</text>
          </g>
          ${useCustomVisuals
            ? this.getMarkerShapeSvg(options.customIcon, palette.fill, palette.stroke, heading)
            : this.getLegacyTruckShapeSvg(palette.fill, palette.stroke, heading)}
      </svg>`;

    return new window.H.map.Icon(svgTruck, {
      size: { w: selectedWidth + 8, h: 80 },
      anchor: { x: 40, y: 40 },
    });
  };

  getClusterIcon = (count) => {
    var radius = Math.min(30, 13 + Math.log(Math.max(count, 1)) * 4);
    var diameter = radius * 2;
    var palette =
      count >= 50
        ? { fill: "#dc2626", stroke: "#fecaca" }
        : count >= 25
          ? { fill: "#f97316", stroke: "#fed7aa" }
          : count >= 10
            ? { fill: "#2563eb", stroke: "#bfdbfe" }
            : { fill: "#16a34a", stroke: "#bbf7d0" };

    var svgIcon = `<svg width="${diameter}" height="${diameter}" viewBox="0 0 ${diameter} ${diameter}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${radius}" cy="${radius}" r="${radius - 2}" fill="${palette.fill}" stroke="${palette.stroke}" stroke-width="3" />
        <text font-size="${Math.max(12, radius * 0.78)}" fill="#ffffff" font-family="Verdana" font-weight="700" text-anchor="middle" dominant-baseline="middle" x="${radius}" y="${radius + 1}">${count}</text>
      </svg>`;

    return new window.H.map.Icon(svgIcon, {
      size: { w: diameter, h: diameter },
      anchor: { x: radius, y: radius },
    });
  };

  renderMarkerGroup = (dataPoints) => {
    if (!window.map) return;

    this.clearClusterLayer();
    this.clearMarkerGroup();

    var markerGroup = new window.H.map.Group();
    var selectedAssetData = null;

    dataPoints.forEach((dataPoint) => {
      var data = dataPoint.data || {};
      if (!data.lat || !data.lng) return;

      if (String(data.assetId) === String(this.props.selectedAssetId)) {
        selectedAssetData = data;
        return;
      }

      var marker = new window.H.map.Marker(
        {
          lat: data.lat,
          lng: data.lng,
        },
        {
	          icon: this.getTruckIcon(data.name, data.heading, false, this.getMarkerStatus(data), {
	            customColour: data.colour,
	            customIcon: data.icon,
	            visualMode: this.props.visualMode,
	            customVisualsEnabled: this.props.customVisualsEnabled,
	          }),
        }
      );

      marker.setData(data);
      marker.addEventListener("tap", this.onMarkerClick);
      markerGroup.addObject(marker);
    });

    window.map.addObject(markerGroup);
    this.markerGroup = markerGroup;

    if (selectedAssetData) {
      this.renderSelectedMarker(selectedAssetData);
    }
  };

  clusterAction = (dataPoints) => {
    this.clearMarkerGroup();

    var unclusterZoomLevel = 14;

    var clusteredDataProvider = new window.H.clustering.Provider(dataPoints, {
      clusteringOptions: {
        eps: 50,
        minWeight: 2,
      },
    });

    var customTheme = {
      getClusterPresentation: (cluster) => {
        var clusterIcon = this.getClusterIcon(cluster.getWeight());

        var minZoom = cluster.getMinZoom();
        var maxZoom = cluster.getMaxZoom();

        if (maxZoom >= unclusterZoomLevel) maxZoom = unclusterZoomLevel - 1;

        // Create a marker for noise points:
        var clusterMarker = new window.H.map.Marker(cluster.getPosition(), {
          icon: clusterIcon,
          min: minZoom,
          max: maxZoom,
        });

        clusterMarker.setData(cluster);
        return clusterMarker;
      },
      getNoisePresentation: (noisePoint) => {
        var data = noisePoint.getData();
        var isSelectedNoisePoint = String(data.assetId) === String(this.props.selectedAssetId);
        var noiseIcon = isSelectedNoisePoint
          ? this.getHiddenIcon()
	          : this.getTruckIcon(data.name, data.heading, false, this.getMarkerStatus(data), {
	            customColour: data.colour,
	            customIcon: data.icon,
	            visualMode: this.props.visualMode,
	            customVisualsEnabled: this.props.customVisualsEnabled,
	          });

        var minZoom = noisePoint.getMinZoom();
        if (minZoom > unclusterZoomLevel) minZoom = unclusterZoomLevel;

        // Create a marker for noise points:
        var noiseMarker = new window.H.map.Marker(noisePoint.getPosition(), {
          icon: noiseIcon,
          min: minZoom,
        });

        // Bind noise point data to the marker:
        noiseMarker.setData(noisePoint);
        return noiseMarker;
      },
    };

    clusteredDataProvider.setTheme(customTheme);

    clusteredDataProvider.addEventListener("tap", this.onMarkerClick);

    var layer = new window.H.map.layer.ObjectLayer(clusteredDataProvider);
    var oldLayer = this.clusterLayer;
    var shouldRemoveOldLayerImmediately = !!this.props.selectedAssetId;

    if (shouldRemoveOldLayerImmediately && oldLayer) {
      window.map.removeLayer(oldLayer);
    }

    window.map.addLayer(layer);
    this.clusterLayer = layer;

    var hasRemoved = shouldRemoveOldLayerImmediately;
    var oldLayerRemovalDelay = this.props.selectedAssetId ? 0 : 200;

    function removeOldLayer() {
      setTimeout(() => {
        if (hasRemoved || !oldLayer) return;
        window.map.removeLayer(oldLayer);
        hasRemoved = true;
      }, oldLayerRemovalDelay);
    }

    // Defer removing the old points until we've rendered the new ones fully
    clusteredDataProvider.addEventListener("end", removeOldLayer);

    // With fallback if not yet removed, like if the window isn't focused
    setTimeout(() => {
      removeOldLayer();
    }, 14000);

    // Just a regular dispose() call causes horrible performance drops, so we're just gonna remove our events manually
    if (window.clusteredDataProvider) {
      window.clusteredDataProvider.removeEventListener(
        "tap",
        this.onMarkerClick
      );
      window.clusteredDataProvider.removeEventListener("end", removeOldLayer);
    }
    window.clusteredDataProvider = clusteredDataProvider;
  };

  onMarkerClick = (event) => {
    var position = event.target.getGeometry();
    var targetData = event.target.getData();

    // If we have a method for fetching a bounding box, we're a cluster
    if (targetData.getBoundingBox) {
      window.map.getViewModel().setLookAtData({
        bounds: targetData.getBoundingBox(),
      });
      return;
    }

    var assetData = targetData.data || (targetData.getData && targetData.getData()) || targetData;

    window.map.setZoom(Math.max(window.map.getZoom(), 16));
    window.map.setCenter(position);
    this.renderSelectedMarker(assetData);

    if (this.props.isFullScreen && assetData) {
      this.handleOpenBubble(position, assetData);
    } else if (this.bubbleObj) {
      this.closeBubble();
    }

    if (this.props.onAssetSelection && assetData) {
      this.props.onAssetSelection(assetData.assetId);
    }
  };

  handleOpenBubble = (position, assetData) => {
    if (this.bubbleObj) {
      this.closeBubble();
    }

    window.map.setCenter(offsetMapLocation(window.map, position, { y: -100 }));

    let bubble = new window.H.ui.InfoBubble(position, {
      content: this.getBubbleContent(assetData),
    });

    window.ui.addBubble(bubble);
    this.bubbleObj = bubble;
  };

  closeBubble = () => {
    if (this.bubbleRoot) {
      this.bubbleRoot.unmount();
      this.bubbleRoot = null;
    }

    if (this.bubbleObj) {
      window.ui.removeBubble(this.bubbleObj);
      this.bubbleObj = null;
    }
  };

  getBubbleContent = (data) => {
    // Create a container div and render the React component into it
    const container = document.createElement("div");
    if (this.bubbleRoot) {
      this.bubbleRoot.unmount();
    }
    this.bubbleRoot = createRoot(container);
    this.bubbleRoot.render(
      <RealMapBubble
        data={data}
        history={this.props.history}
        setErrorMessageAction={this.props.setErrorMessageAction}
      />
    );
    return container;
  };

  renderMapControls = () => {
    if (!this.props.showMapControls) return null;

    var hasSelectedAsset = !!this.props.selectedAssetId;
    var scrollLockEnabled = !!this.state.controlScrollLockEnabled;
    var clusteringEnabled = this.state.controlClusteringEnabled !== false;
    var followSelectedAsset = !!this.state.controlFollowSelectedAsset;
    var hideClusterControl = !!this.props.hideClusterControl;
    var hideClearControl = !!this.props.hideClearControl;
    var useHeadingFollowToggle = !!this.props.useHeadingFollowToggle;

    return (
      <div
        className="map-overlay-heading"
        key={`map-controls-${this.state.controlVersion}`}
        onMouseDown={this.stopOverlayMapInteraction}
        onTouchStart={this.stopOverlayMapInteraction}
        onWheel={this.stopOverlayMapInteraction}
      >
        <span
          className={useHeadingFollowToggle ? (followSelectedAsset ? "map-follow-label active" : "map-follow-label paused") : ""}
          role={useHeadingFollowToggle ? "button" : undefined}
          tabIndex={useHeadingFollowToggle ? 0 : undefined}
          onClick={useHeadingFollowToggle ? this.handleControlFollowToggle : undefined}
          onKeyDown={useHeadingFollowToggle ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.handleControlFollowToggle(event);
            }
          } : undefined}
          title={useHeadingFollowToggle ? (followSelectedAsset ? "Following asset" : "Resume following asset") : undefined}
        >
          <i className="fa fa-location-arrow"></i>
          {this.props.headingLabel || "Select an asset"}
        </span>
        <div className="map-overlay-actions">
          <button
            type="button"
            className="real-icon-button map-fullscreen-toggle active"
            onClick={this.props.onFullscreenToggle}
            title={this.props.isFullScreen ? "Exit fullscreen" : "Open map fullscreen"}
          >
            <i className={this.props.isFullScreen ? "fa fa-compress" : "fa fa-expand"}></i>
          </button>
          <button
            type="button"
            className={scrollLockEnabled ? "real-icon-button map-lock-toggle active" : "real-icon-button map-lock-toggle"}
            onClick={this.handleControlScrollLockToggle}
            title={scrollLockEnabled ? "Scroll lock on" : "Scroll lock off"}
          >
            <i className={scrollLockEnabled ? "fa fa-lock" : "fa fa-unlock"}></i>
          </button>
          {!useHeadingFollowToggle && (
            <button
              type="button"
              className={followSelectedAsset ? "real-icon-button map-follow-toggle active" : "real-icon-button map-follow-toggle"}
              onClick={this.handleControlFollowToggle}
              disabled={!hasSelectedAsset}
              title={!hasSelectedAsset ? "Select an asset first" : followSelectedAsset ? "Following selected asset" : "Follow selected asset"}
            >
              <i className="fa fa-crosshairs"></i>
            </button>
          )}
          {!hideClusterControl && (
            <button
              type="button"
              className={clusteringEnabled ? "real-icon-button map-cluster-toggle active" : "real-icon-button map-cluster-toggle"}
              onClick={this.handleControlClusteringToggle}
              title={clusteringEnabled ? "Clustering on" : "Clustering off"}
            >
              <i className="fa fa-th-large"></i>
            </button>
          )}
          {!hideClearControl && (
            <button
              type="button"
              className="real-icon-button map-clear-toggle"
              onClick={this.handleClearSelectedAsset}
              disabled={!hasSelectedAsset}
              title={hasSelectedAsset ? "Clear selected asset" : "No asset selected"}
            >
              <i className="fa fa-arrow-left"></i>
            </button>
          )}
        </div>
      </div>
    );
  };

  renderFullscreenFilters = () => {
    if (!this.props.isFullScreen || !this.props.fullscreenFilterContent) return null;

    if (this.state.fullscreenFiltersHidden) {
      return (
        <button
          type="button"
          className="fullscreen-filter-show"
          onClick={this.showFullscreenFilters}
          onMouseDown={this.stopOverlayMapInteraction}
          onTouchStart={this.stopOverlayMapInteraction}
          title="Show map filters"
        >
          Filters
        </button>
      );
    }

    return (
      <div
        className="fullscreen-filter-overlay"
        onMouseDown={this.stopOverlayMapInteraction}
        onTouchStart={this.stopOverlayMapInteraction}
        onWheel={this.stopOverlayMapInteraction}
      >
        <div className="fullscreen-filter-header">
          <span>Map Filters</span>
          <button type="button" onClick={this.hideFullscreenFilters} title="Hide map filters">
            Hide
          </button>
        </div>
        {this.props.fullscreenFilterContent}
      </div>
    );
  };

  renderFullscreenDriverContent = () => {
    if ((!this.props.isFullScreen && !this.props.showDriverOverlay) || !this.props.fullscreenDriverContent) return null;

    return (
      <div
        className={this.props.showDriverOverlay ? "fullscreen-driver-overlay list-driver-overlay" : "fullscreen-driver-overlay"}
        aria-label={this.props.driverOverlayLabel || "Selected asset driver and incidents"}
        onMouseDown={this.stopOverlayMapInteraction}
        onTouchStart={this.stopOverlayMapInteraction}
        onWheel={this.stopOverlayMapInteraction}
      >
        {this.props.showDriverOverlay ? <>
          <div className="map-zoom-indicator">Zoom: {this.state.zoomLevel}</div>
          <div className="list-driver-overlay-tiles">{this.props.fullscreenDriverContent}</div>
        </> : this.props.fullscreenDriverContent}
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div id="realMapContainer" tabIndex="0">
          {this.props.mapOverlayContent && <div
            className={[
              "erp-map-overlay-host",
              this.props.mapOverlayMinimized ? "minimized" : "",
              this.props.isFullScreen && this.props.fullscreenFilterContent && !this.state.fullscreenFiltersHidden
                ? "fullscreen-filters-open"
                : "",
            ].filter(Boolean).join(" ")}
            onMouseDown={this.stopOverlayMapInteraction}
            onTouchStart={this.stopOverlayMapInteraction}
            onWheel={this.stopOverlayMapInteraction}
          >{this.props.mapOverlayContent}</div>}
          {this.renderFullscreenFilters()}
          {this.renderFullscreenDriverContent()}
          {this.renderMapControls()}
          {!this.props.showDriverOverlay && <div className="map-zoom-indicator">
            Zoom: {this.state.zoomLevel}
          </div>}
          <div id="mapScrollBlock">
            {this.props.scrollLockEnabled && (
              <div className="map-scroll-message">
                Hold Ctrl + scroll to zoom the map
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RealMap;
